import { Component, OnInit, Input } from '@angular/core';
import { Breadcrumb } from '../../interfaces/Organization';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { SieniService } from '../../services/sieni.service';
import { TranslateService } from '@ngx-translate/core';
import { Alert } from '../../models/alert.model';
import { IdToolboxSIENI, IdToolboxMAIL } from '../../models/toolbox.model';
import { GlobalsService } from '../../services';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {


  constructor(private _location: Location, private _router: Router,
    private _globalService: GlobalsService,
    private _sieniService: SieniService,
    private translate: TranslateService) { }

  @Input() public back: boolean = false;
  @Input() public crumbs: Breadcrumb[];
  @Input() public hash: string = null;

  public sending: boolean = false;

  ngOnInit() {
  }

  public return(){
    this._location.back()
  }

  public openMail(){
    this.sending = true;
    this._sieniService.getCurrentOrganization().then((data)=>{
      this.sending = false;
      const currentOrganizacion = data;
      const user = sessionStorage.getItem('activeUser');
      const currentUser = user !== undefined ? JSON.parse(user) : undefined;
      if(!!currentOrganizacion && !!currentUser){
        currentUser.children = [];
        const toolboxMail = currentOrganizacion.toolboxes.find( item => item.id == IdToolboxMAIL);
        const json: any = JSON.stringify({
          user: currentUser,
          organization: currentOrganizacion
        });
        const token =  btoa(unescape(encodeURIComponent(json)));
        var win = window.open(toolboxMail.url + '?toolbox='+ IdToolboxSIENI +'&code=' + token  );
       } else {
        Alert.buildErrorAlert(this.translate.instant('breadCrumbs.alert.error-mail'));
      };
    }).catch((error)=>{
      console.error(error);
      this.sending = false;
      Alert.buildErrorAlert(this.translate.instant('breadCrumbs.alert.error-mail'));
    });

  }

  public openHelp(){
    this.sending = true;
     if (!this.hash){
      this.hash = window.location.hash.replace('#/','').replace(/\d+/g, "*");
      console.warn('Ruta sugerida para la ayuda: ',this.hash);
    }
    if(this.hash){
      this._sieniService.getHelp(this.hash, 1).subscribe((res:any)=>{
        this.sending = false
        var win = window.open(res.data.url, "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=780,height=200,top="+(screen.height-400)+",left="+(screen.width-840));
      }, (error)=>{
        console.log(error);
        this.sending = false
        Alert.buildErrorAlert(this.translate.instant('breadCrumbs.alert.error-help'))
      })
    }
  }

}
